import { inputResult } from "../Submit/SaveAnswer";


export function transformDrToSelf(input:JQuery, results:inputResult, points:number, possible:number){
    
    const labels = input.find(".label-item");

    // Hide used data-labels
    input.find(".drag-drop[data-target!=-1]").remove();

    // Loop through fields
    labels.each((ind, obj) => {
        // Disable Field
        const input = $(obj).find(".drag-target");

        input.html(results.answer[ind].value);
        
    })

}